import i from 'i18next'

import { contexts } from '~/modules/retailMedia/constants'

export const removeUndefined = (
  obj: FormDataRequestAds | PayloadRequestAds | PlacementRequest
) =>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  Object.fromEntries(Object.entries(obj).filter(([key, v]) => v !== undefined))

/**
 * Function used to generate the campaign URL based on the clickUrl
 */
export const getCampaignUrl = (clickUrl: string) => {
  if (!clickUrl || typeof clickUrl !== 'string') {
    return ''
  }

  const urlObj = new URL(clickUrl)
  const campaignId = urlObj.searchParams.get('campaign_id')

  if (!campaignId) {
    return ''
  }

  return `/retail-media/campaign/view/${campaignId}`
}

/**
 * Function used to get the ad type that should be used in ad request for a given type
 */
export const getRequestAdType = (type: CampaignAdType) => {
  const baseAdTypes: Partial<Record<CampaignAdType, CampaignAdType>> = {
    banner_off_site: 'banner',
    sponsored_brand_video: 'sponsored_brand',
    banner_video: 'banner'
  }

  return baseAdTypes[type] ?? type
}

/**
 * Function used to get the context options
 */
export const getContextOptions = (): RadioOptionProps[] => {
  const capitalizeTranslated = (value: string) =>
    i.t('common:capitalize', { value }) as string

  return contexts.map(context => {
    const value = i.t(`rm:context.${context}.short`) as string

    return {
      label: capitalizeTranslated(value),
      value: context
    }
  })
}

/**
 * Function used to get the ad types options
 */
type GetAdTypesOptions = (adTypes: CampaignAdType[]) => RadioOptionProps[]

export const getAdTypesOptions: GetAdTypesOptions = adTypes => {
  if (!Array.isArray(adTypes)) {
    return []
  }

  const filterTypes = adTypes.filter(
    adType => !['digital_signage'].includes(adType)
  )

  const capitalizeTranslated = (value: string) =>
    i.t('common:capitalize', { value }) as string

  const mapFN = (adType: CampaignAdType) => ({
    label: capitalizeTranslated(i.t(`rm:${adType}`)),
    value: adType
  })

  const mappedTypes = filterTypes.map(mapFN)

  return mappedTypes
}
